const createStyleTemplate = (styles) => {
  const template = document.createElement("template");
  template.innerHTML = `<style>${styles}</style>`;
  return template;
};
export {
  createStyleTemplate
};
//# sourceMappingURL=createStyleTemplate.js.map
